import { Component, HostBinding, Input } from '@angular/core';
import { environment } from "src/environments/environment";

@Component({
    standalone: false,
    selector: 'sm-sync-status',
    templateUrl: './sm-sync-status.component.html',
    styleUrls: ['./sm-sync-status.component.scss']
})
export class SmSyncStatusComponent {

    @HostBinding('class.aurora-enabled') public readonly auroraEnabled = environment.auroraV1 === 'true';

    @Input() status: SyncStatus;
    @Input() placement: string = "left";
    public syncClass: string;

    public get popoverPosition(): string {
        switch (this.placement) {
            case 'bottom-right':
                return 'bottom right';
            case 'bottom-left':
                return 'bottom left';
            case 'bottom':
            case 'bottom-center':
                return 'bottom center';
            case 'top-right':
                return 'top right';
            case 'top-left':
                return 'top left';
            case 'top':
            case 'top-center':
                return 'top center';
            case 'right':
            case 'right-center':
                return 'right center';
            case 'left':
            case 'left-center':
            default:
                return 'left center';
        }
    }

    ngOnChanges() {
        this.syncClass = this.status.toLowerCase();
    }
}

export enum SyncStatus {
    Connected = "Connected",
    Disconnected = "Disconnected",
    Reconnecting = "Reconnecting"
}
